import { AxiosResponse } from "axios";
import { axiosConfig } from "../../../config/api/configApi";

export const getSurveyStudent: (data: any, id: any, tab: any) => Promise<AxiosResponse<any>> = (data: any, id: any, tab: any) => {
    return axiosConfig.post(`/survey-student/search/${id}/${tab}`, data);
};

export const getListNumberSurveyStudent: (id: any ) => Promise<AxiosResponse<any>> = (id: any) => {
    return axiosConfig.get(`/survey-student/getAllListSurvey/${id}`);
};